module.exports = __webpack_public_path__ + "components/flag/static/square/sa-4b78c6931628bea7b9c1e01e2d7d14ea.svg";